import { ProjectManagementStatus } from '@round/api';
import Select from 'ui/DataEntry/Select/Select';
import { StylesConfig, ValueType } from 'react-select';
import { getValue, projectStatusMeta, projectStatusOptions } from './helpers';
import { CSSProperties } from 'react';
import { Option, SingleValue } from './ProjectStatusComponents';

const selectStyles: StylesConfig = {
    control: (base, state) => {
        const value = getValue(state.getValue());
        const color = value && value.value ? projectStatusMeta[value.value].color : 'transparent';
        return {
            ...base,
            padding: '0.125rem 0.75rem',
            border: `1px solid ${value ? color : 'var(--border-color, #e2e8f0)'}`,
            borderRadius: '0.75rem',
            columnGap: '0.25rem',
            background: 'var(--Surface-White)',
            ':hover': {
                padding: '0.125rem 0.75rem',
                border: `1px solid ${value ? color : 'var(--border-color, #e2e8f0)'}`,
                borderRadius: '0.75rem',
            },
            '& input[readonly]': {
                height: 0,
            },
        };
    },
    indicatorsContainer: (base) => ({
        ...base,
        padding: 0,
        height: 'auto',
        ':hover': { padding: 0, height: 'auto' },
    }),
    valueContainer: (base) => ({ ...base, padding: '0 0.25rem', gap: 0, ':hover': { gap: 0 } }),
    singleValue: (base) => ({
        ...base,
        fontSize: '0.75rem',
        fontWeight: 500,
        position: 'static',
        top: 'auto',
        transform: 'none',
        maxWidth: 'none',
        whiteSpace: 'nowrap',
    }),
    menu: (base) => ({
        ...base,
        right: 0,
        left: 'auto',
        width: '16rem',
    }),
    option: (base, state) => {
        const active = base[':active' as keyof CSSProperties] as CSSProperties;
        return {
            ...base,
            fontWeight: 500,
            fontSize: '0.75rem',
            color: '#242424',
            background: state.isSelected || state.isFocused ? '#f1f5f9' : base.background,
            ':active': {
                ...active,
                background: '#e2e8f0',
            },
        };
    },
    placeholder: (base) => ({
        ...base,
        position: 'static',
        top: 'auto',
        transform: 'none',
        whiteSpace: 'nowrap',
        fontWeight: 500,
        fontSize: '0.75rem',
    }),
};

type Props = {
    value: ProjectManagementStatus | null;
    onChange: (next: ProjectManagementStatus) => void;
};

const ProjectStatusSelect = ({ value, onChange }: Props) => {
    const selectedItem = projectStatusOptions.find((o) => o.value === value) ?? null;
    return (
        <Select
            styles={selectStyles}
            isMulti={false}
            isClearable={false}
            isSearchable={false}
            placeholder="Set project status"
            options={projectStatusOptions}
            value={selectedItem}
            onChange={(v) => {
                const picked = getValue(v as ValueType<{}, boolean>);
                if (picked) {
                    onChange(picked.value);
                }
            }}
            components={{ SingleValue, Option }}
        />
    );
};

export default ProjectStatusSelect;
